export const SET_ADMIN_PROFILE = 'accountSettingsPage/SET_ADMIN_PROFILE'
export const SET_ADMIN_PROFILE_SUCCESS = 'accountSettingsPage/SET_ADMIN_PROFILE_SUCCESS'
export const SET_ADMIN_PROFILE_ERROR = 'accountSettingsPage/SET_ADMIN_PROFILE_ERROR'

export const GET_ADMIN_PROFILE = 'accountSettingsPage/GET_ADMIN_PROFILE'
export const GET_ADMIN_PROFILE_SUCCESS = 'accountSettingsPage/GET_ADMIN_PROFILE_SUCCESS'
export const GET_ADMIN_PROFILE_ERROR = 'accountSettingsPage/GET_ADMIN_PROFILE_ERROR'

export const EDIT_ADMIN_PASSWORD = 'accountSettingsPage/EDIT_ADMIN_PASSWORD'
export const EDIT_ADMIN_PASSWORD_SUCCESS = 'accountSettingsPage/EDIT_ADMIN_PASSWORD_SUCCESS'
export const EDIT_ADMIN_PASSWORD_ERROR = 'accountSettingsPage/EDIT_ADMIN_PASSWORD_ERROR'

export const SET_CURRENT_PROFILE_IMG = 'accountSettingsPage/SET_CURRENT_PROFILE_IMG'
export const SET_CURRENT_PROFILE_IMG_SUCCESS = 'accountSettingsPage/SET_CURRENT_PROFILE_IMG_SUCCESS'
export const SET_CURRENT_PROFILE_IMG_ERROR = 'accountSettingsPage/SET_CURRENT_PROFILE_IMG_ERROR'

export const SET_PASSWORD_ERROR_MESSAGE = 'accountSettingsPage/SET_PASSWORD_ERROR_MESSAGE'
export const SET_IS_PROFILE_INFO_EDIT_SUCCESS = 'accountSettingsPage/SET_IS_PROFILE_INFO_EDIT_SUCCESS'
export const SET_ERROR_MSG = 'accountSettingsPage/SET_ERROR_MSG'
export const SET_TABS = 'accountSettingsPage/SET_TABS'
export const SET_IS_EDIT_SUCCESS = 'accountSettingsPage/SET_IS_EDIT_SUCCESS'

export const CHANGE_TABS = 'accountSettingsPage/CHANGE_TABS'

export const RESET_ADMIN_PROFILE_IMG = 'accountSettingsPage/RESET_ADMIN_PROFILE_IMG'
